module.exports = __webpack_public_path__ + "media/images/emblems/Jussy-coat_of_arms-4e9708c40a6fda42cf8b9d6afe79bd63.svg";